import React from "react";
import PropTypes from "prop-types";
import { Button } from "./Button";

import "./style.scss";
import { MCStateContext } from "../../../..";

/**
 * ButtonControls:
 *   to render the button controls in settings
 */
export function ButtonControls(props) {
  const { running } = React.useContext(MCStateContext);

  const onClickIncrement = () => !running && props.increment();
  const onClickDecrement = () => !running && props.decrement();

  const onKeyPressIncrement = (event) => {
    if (event.code == "Enter" || event.code == "Space") {
      onClickIncrement();
    }
  };

  const onkeyPressDecrement = (event) => {
    if (event.code == "Enter" || event.code == "Space") {
      onClickDecrement();
    }
  };

  return (
    <div className="mc_settings_buttonControl">
      <Button
        onClick={onClickIncrement}
        onKeyPress={onKeyPressIncrement}
        disabled={running}
        altText={props.altText1}
      />
      <span className="mc_settings_buttonControl_text">{props.text}</span>
      <Button
        rotate={true}
        onClick={onClickDecrement}
        onKeyPress={onkeyPressDecrement}
        disabled={running}
        altText={props.altText2}
      />
    </div>
  );
}

ButtonControls.propTypes = {
  /**
   * callback to trigger on click of top button (increment button)
   */
  increment: PropTypes.func,
  /**
   * callback to trigger on click of bottom button (decrement button)
   */
  decrement: PropTypes.func,
  /**
   * text displayed between both buttons
   */
  text: PropTypes.string,
};

ButtonControls.defaultProps = {
  text: "",
};
